import { ExcelGridConfig } from 'src/utils/excel/excelGridConfig';
import { EQM4010_R01DetailDto, EQM4010_R01HeaderDto } from './Dto_EQM4010_R01';

export const EQM4010_R01_EXCEL_HEADER_NAMES: Record<string, string> = {
	rowIndex: '',
	moldCleanNo: '세척No.',
	compNm: '사업장',
	moldCd: '금형코드',
	moldNm: '금형명',
	cleanType: '세척구분',
	cleanDt: '세척일자',
	shotCount: '세척현재타수',
	cleanWorker: '작업자',
	cleanWorkerNm: '작업자명',
	remark: '비고',
};

export const EQM4010_R01_EXCEL_COLUMN_ORDER = [
	'moldCleanNo', 'compNm', 'moldCd', 'moldNm', 'cleanType', 'cleanDt', 'shotCount', 'cleanWorker', 'cleanWorkerNm', 'remark',
];

export const createEQM4010ExcelConfig = (
	selectedMold: EQM4010_R01HeaderDto | null,
	defaultRow: EQM4010_R01DetailDto
): ExcelGridConfig<EQM4010_R01DetailDto> => ({
	headerNames: EQM4010_R01_EXCEL_HEADER_NAMES,
	columnOrder: EQM4010_R01_EXCEL_COLUMN_ORDER,
	defaultRow,
	template: {
		sheetName: '금형세척 템플릿',
		fileNamePrefix: '금형세척_업로드_템플릿',
		colWidths: [14, 10, 12, 18, 12, 12, 12, 12, 20],
	},
	requiredHeaders: ['세척일자'],
	validateBeforeUpload: () => (!selectedMold ? '금형을 먼저 선택해주세요.' : null),
	createRowMeta: (_row, _index, valueIndex) => ({
		valueIndex,
		inserted: true,
		isModified: true,
		moldCd: selectedMold!.moldCd,
		moldNm: selectedMold!.moldNm,
	}),
});
